export const currentStateUrl = 'current-state/';
export const mapCurrentStateUrl = 'current-state/map/';
export const publicCurrentStateUrl = (shareLinkId: string) => `external/share-link/${shareLinkId}/current-state/`;
export const publicMapCurrentStateUrl = (shareLinkId: string) =>
  `external/share-link/${shareLinkId}/current-state/map/`;
